export class NgxGalleryLayout {
    static ThumbnailsTop: string = 'thumbnails-top';
    static ThumbnailsBottom: string = 'thumbnails-bottom';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/~/ngx-gallery/lib/ngx-gallery-layout.model.ts